import { BoothStatusData, FeatureFlagsDto, PlatformType, type Booth } from '@cibli/shared';
import { createContext } from 'react';

import { usePrinter } from '../hooks/usePrinter';

export type UseBoothError = 'lookup_failed';

export type BoothContextType = ReturnType<typeof usePrinter> & {
  status: BoothStatusData | null;
  booth: Booth | Partial<Booth> | null;
  loading: boolean;
  error: UseBoothError | null;
  isBooth: boolean;
  isWeb: boolean;
  platformType: PlatformType | null;
  webRegionConfig?: import('@cibli/shared').WebRegionResolveResponse | null;
  // Feature flags
  featureFlags: FeatureFlagsDto | null;
  isDevNoInterviewEnabled: boolean;
  isSimulationModeEnabled: boolean;
  isKioskDashboardButtonEnabled: boolean;
  isDevOtpBypassEnabled: boolean;
  isMaintenanceModeEnabled: boolean;
  isSecretPinEnabled: boolean;
  isCvThemesEnabled: boolean;
  isBoothDefaultLocaleEnabled: boolean;
  loadFeatureFlags: () => Promise<void>;
  printerAvailable: boolean;
};

export const BoothContext = createContext<BoothContextType | null>(null);
